import React, { useState, useEffect } from 'react';
import './GeneralSettingPage.css';
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn
} from 'mdb-react-ui-kit';

const GeneralSettingPage = () => {

  const [settings, setSettings] = useState({
    username: '',
    companyName: '',
    currency: '',
    skuFormat: '',
    descriptionMode: 'formatting',
    customPrompt: '',
  });

  const [vendors, setVendors] = useState([]);
  const [newVendor, setNewVendor] = useState('');

  // 🔹 Dummy backend simulation
  useEffect(() => {
    setSettings({
      username: 'ammar_fahim',
      companyName: 'Ammar Store',
      currency: 'USD',
      skuFormat: 'SKU-###',
      descriptionMode: 'custom',
      customPrompt: 'Generate SEO friendly description',
    });

    setVendors(['Default Vendor', 'Nike Supplier']);
  }, []);

  const handleChange = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const addVendor = () => {
    if (!newVendor.trim()) return;
    setVendors(prev => [...prev, newVendor]);
    setNewVendor('');
  };

  const removeVendor = (index) => {
    setVendors(prev => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    const payload = { ...settings, vendors };
    console.log('Saved Settings:', payload);
    alert('Settings saved (simulated)');
  };

  return (
    <div className="settings-page">

      <h1 className="page-title">General Settings</h1>

      {/* ================= Account Settings ================= */}
      <div className="settings-card">
        <h4 className="section-title">Account Settings</h4>

        <MDBRow>
          <MDBCol md="6">
            <MDBInput
              label="Username"
              size="lg"
              className="mb-3"
              value={settings.username}
              onChange={(e) => handleChange('username', e.target.value)}
            />
          </MDBCol>

          <MDBCol md="6">
            <MDBInput
              label="Company Name"
              size="lg"
              className="mb-3"
              value={settings.companyName}
              onChange={(e) => handleChange('companyName', e.target.value)}
            />
          </MDBCol>
        </MDBRow>
      </div>

      {/* ================= Listing Settings ================= */}
      <div className="settings-card">
        <h4 className="section-title">Listing Settings</h4>

        <MDBRow>
          <MDBCol md="6">
            <MDBInput
              label="Currency"
              size="lg"
              className="mb-3"
              value={settings.currency}
              onChange={(e) => handleChange('currency', e.target.value)}
            />
          </MDBCol>

          <MDBCol md="6">
            <MDBInput
              label="SKU Format"
              size="lg"
              className="mb-3"
              value={settings.skuFormat}
              onChange={(e) => handleChange('skuFormat', e.target.value)}
            />
          </MDBCol>
        </MDBRow>
      </div>

      {/* ================= Vendor List ================= */}
      <div className="settings-card">
        <h4 className="section-title">Vendor List</h4>

        <div className="vendor-input-row">
          <MDBInput
            label="Add Vendor"
            size="lg"
            value={newVendor}
            onChange={(e) => setNewVendor(e.target.value)}
          />
          <MDBBtn color="primary" size="lg" onClick={addVendor}>
            Add
          </MDBBtn>
        </div>

        <div className="vendor-list">
          {vendors.map((vendor, index) => (
            <div key={index} className="vendor-item">
              <span>{vendor}</span>
              <MDBBtn
                size="sm"
                color="danger"
                onClick={() => removeVendor(index)}
              >
                Remove
              </MDBBtn>
            </div>
          ))}
        </div>
      </div>

      {/* ================= Description Settings ================= */}
      <div className="settings-card">
        <h4 className="section-title">Description Settings</h4>

        <select
          className="form-select form-select-lg mb-3"
          value={settings.descriptionMode}
          onChange={(e) => handleChange('descriptionMode', e.target.value)}
        >
          <option value="formatting">Description Formatting</option>
          <option value="ai">AI Description</option>
          <option value="html">HTML AI Description</option>
          <option value="custom">Custom Description Prompt</option>
        </select>

        {settings.descriptionMode === 'custom' && (
          <MDBInput
            label="Custom Description Prompt"
            size="lg"
            className="mb-3"
            value={settings.customPrompt}
            onChange={(e) => handleChange('customPrompt', e.target.value)}
          />
        )}
      </div>

      <div className="save-wrapper">
        <MDBBtn color="success" size="lg" onClick={handleSave}>
          Save Settings
        </MDBBtn>
      </div>

    </div>
  );
};

export default GeneralSettingPage;
